import { mainLocator as locator } from '@core/di/main.locator';
import { SequenceRepository } from '@core/sequence.repository';
import { UiService } from '@core/services/ui.services';
import TechnicalSheetRepository from '@modules/chefs-assistant/pages/technical-sheets/technical-sheet.repository';
import { TechnicalSheetStore } from '@modules/chefs-assistant/pages/technical-sheets/technical-sheet.store';
import ProductCache from '@modules/chefs-assistant/services/product.cache';

locator.register('TechnicalSheetRepository', TechnicalSheetRepository);
locator.registerInstance(
  'TechnicalSheetStore',
  new TechnicalSheetStore(
    locator.resolve<UiService>('UiService'),
    locator.resolve<SequenceRepository>('SequenceRepository'),
    locator.resolve<ProductCache>('ProductCache'),
    locator.resolve<TechnicalSheetRepository>('TechnicalSheetRepository'),
  ),
);
